import { Cartesian3, Color } from "cesium";
import { EarthBrainUtils } from "../utilities/earthbrainutility";
export class EarthBrainViewerAPIs {
    _scDesign;
    //HightMap Viwer
    activateHightmap() {
        this._scDesign.setHightMapActivate();
    }
    inactivateHightmap() {
        this._scDesign.setHightMapInactivate();
    }
    //2D Viewer
    clear2DViewes() {
        this._scDesign.clear2DViews();
    }
    getCanvasForView(viewName) {
        return this._scDesign.getCanvasForView(viewName);
    }
    resize2dView(size, viewName) {
        this._scDesign.resize2dView(size, viewName);
    }
    setSectionViewLabels(labels) {
        this._scDesign.setSectionViewLabels(labels);
    }
    pickPathandPoint(x, y, viewerName) {
        return this._scDesign.pickPathandPoint(x, y, viewerName);
    }
    pickTrenchEntities(x, y, viewerName) {
        return this._scDesign.pickTrenchEntities(x, y, viewerName);
    }
    //3d Viewer
    /**
     * The function will check whether the mouse is dragged after right clickng & before releasing it
     * @returns returns true or false which helps to decide whether context menu should duplay or not in creation mode
     */
    isMouseDraggedAfterRightClick() {
        return this._scDesign.isMouseDraggedAfterRightClick();
    }
    // Features
    async undo() {
        await this._scDesign.undo();
    }
    async redo() {
        await this._scDesign.redo();
    }
    /**
     * API used to zoom in to the road attached with given road ID
     * @param roadID
     */
    fitToRoad(roadID) {
        this._scDesign.fitToRoad(roadID);
    }
    /**
     * Changes the road in 2D viewer for both cross section and logitudinal
     * @param roadID roadID of the road which needs to be displayed in 2D viewer
     */
    // public changeRoadIn2DViewer(roadID: string) {
    //     this._scDesign.changeRoadIn2DViewer(roadID);
    // }
    /**
     * Updates the visibility of the road related to provided roadID
     * @param roadID
     * @param show
     */
    toggleRoadVisibility(roadID, show) {
        this._scDesign.toggleRoadVisibility(roadID, show);
    }
    /**
     * Updates the slope rendered in Altitude view, slope type can be ratio or percent
     * @param slopeTextRenderType
     */
    updateLongitudeRenderingType(slopeTextRenderType) {
        this._scDesign.updateLongitudeRenderingType(slopeTextRenderType);
    }
    /**
     * Rerender the altitude view considering the new unit type.
     * @param unitType
     */
    updateViewerUnit(unitType) {
        this._scDesign.updateViewerUnit(unitType);
    }
    getViewerUnit() {
        return this._scDesign.getViewerUnit();
    }
    /**
     * Returns the object containing minimum elevation and maximum elevation of the road
     * @param roadID
     * @returns
     */
    getRoadHeightInfoOfSection(roadID, startIndex, endIndex) {
        return this._scDesign.getRoadHeightInfoOfSection(roadID, startIndex, endIndex);
    }
    /**
     * Returns the object containing minimum slope value and maximum slope value of the road
     * @param roadID
     * @returns
     */
    getRoadSlopeInfoOfSection(roadID, startIndex, endIndex) {
        return this._scDesign.getRoadSlopeInfoOfSection(roadID, startIndex, endIndex);
    }
    /**
     * examples
     * @param id
     * @param type
     * @param value
     */
    updateTilesetTransparency(id, type, value) {
        this._scDesign.updateTilesetTransparency(Number.parseInt(id), type, value);
    }
    updateTilesetColor(id, color, type) {
        this._scDesign.updateTilesetColor(Number.parseInt(id), color, type);
    }
    updateTilesetVisibility(id, type, status) {
        this._scDesign.updateTilesetVisibility(Number.parseInt(id), type, status);
    }
    zoomToTileset(id, type) {
        this._scDesign.zoomToTileset(Number.parseInt(id), type);
    }
    async addTileset(id, type, input, tileAssetOption) {
        return await this._scDesign.addTileset(id, type, input, tileAssetOption);
    }
    removeTileset(id, type) {
        this._scDesign.removeTileset(id, type);
    }
    // /**
    //  * Enables the picking on cesium view
    //  * @param pickingCallback
    //  */
    // public enablePickingOnCesiumView(pickingCallback: PickingCallback) {
    //   this._scDesign.enablePickingOnCesiumView(pickingCallback);
    // }
    // /**
    //  * Disables the picking on cesium view
    //  */
    // public disablePickingOnCesiumView() {
    //   this._scDesign.disablePickingOnCesiumView();
    // }
    /**
     *
     * @param longitude
     * @param latitude
     * @param color Should be a css string
     * @returns ID of the PIN Added
     */
    addPin(longitude, latitude, color) {
        return this._scDesign.addPin(longitude, latitude, color);
    }
    removePin(id) {
        return this._scDesign.removePin(id);
    }
    updatePin(id, data) {
        return this._scDesign.updatePin(id, data);
    }
    focusPin(id) {
        return this._scDesign.focusPin(id);
    }
    makeTerrainTransparent(status, near, nearTransparancyValue, far, farTransparancyValue) {
        this._scDesign.makeTerrainTransparent(status, near, nearTransparancyValue, far, farTransparancyValue);
    }
    toggleGlobeVisibility(visibility) {
        this._scDesign.toggleGlobeVisibility(visibility);
    }
    clear() {
        this._scDesign.clear();
    }
    focusSiteLocation(longitude, latitude) {
        this._scDesign.focusSiteLocation(longitude, latitude);
    }
    zoomInSite() {
        this._scDesign.zoomInSite();
    }
    zoomOutSite() {
        this._scDesign.zoomOutSite();
    }
    flyToLongLatHeight({ longitude, latitude, height, duration = 0, }) {
        this._scDesign.flyToLongLatHeight({
            longitude,
            latitude,
            height,
            duration,
        });
    }
    setTopViewCameraToObject(objectId) {
        this._scDesign.setTopViewCameraToObject(objectId);
    }
    showGlobe() {
        this._scDesign.showGlobe();
    }
    requestRender() {
        this._scDesign.requestRender();
    }
    async updateSlopeBreaksFromLongitudinalView(roadId, data) {
        await this._scDesign.updateSlopeBreaksFromLongitudinalView(roadId, data);
    }
    // public getDMSCoordinates(pageX: number, pageY: number) {
    //     return this._scDesign.getDMSCoordinates(pageX, pageY);
    // }
    getXYZCoordinates(offsetX, offsetY) {
        return this._scDesign.getXYZCoordinates(offsetX, offsetY);
    }
    clearCommandManager() {
        this._scDesign.clearCommandManager();
    }
    getSlopeBreaks(roadId) {
        return this._scDesign.getSlopeBreaks(roadId);
    }
    // public getTrenchSlopeBreaks(trench: string) {
    //     return this._scDesign.getTrenchSlopeBreaks(trench);
    // }
    getSlopeBreakPointInfoOnRoad(roadId, slopeBreakIndex) {
        return this._scDesign.getSlopeBreakPointInfoOnRoad(roadId, slopeBreakIndex);
    }
    getAltitude(point) {
        return EarthBrainUtils.getAltitude(new Cartesian3(point.x, point.y, point.z));
    }
    renderPoint(x, y, z, color) {
        return this._scDesign.renderPoint(new Cartesian3(x, y, z), Color.fromCssColorString(color));
    }
    renderLocalPoint(x, y, z, color) {
        return this._scDesign.renderLocalPoint(new Cartesian3(x, y, z), Color.fromCssColorString(color));
    }
    renderLocalLine(points, color) {
        return this._scDesign.renderLocalLine(Cartesian3.unpackArray(points), Color.fromCssColorString(color));
    }
    renderPlane(position, normal, color) {
        const p = Cartesian3.fromArray(position);
        const n = Cartesian3.fromArray(normal);
        Cartesian3.normalize(n, n);
        return this._scDesign.renderPlane(p, n, Color.fromCssColorString(color));
    }
    renderRay(origin, direction, color) {
        const o = Cartesian3.fromArray(origin);
        const d = Cartesian3.fromArray(direction);
        Cartesian3.normalize(d, d);
        return this._scDesign.renderRay(o, d, Color.fromCssColorString(color));
    }
    updateRoadAndFlatLabelColors(color) {
        this._scDesign.updateRoadAndFlatLabelColors(color);
    }
    getConnectionsInSiteJSON() {
        return JSON.stringify(this._scDesign.getConnectionsInSiteJSON());
    }
    loadConnectionsInSiteJSON(jsonString) {
        this._scDesign.loadConnectionsInSiteJSON(jsonString);
    }
    /**
     * Updates the visibility of the trench related to provided trenchID
     * @param trenchID
     * @param show
     */
    setTrenchVisibility(trenchID, show) {
        this._scDesign.setTrenchVisibility(trenchID, show);
    }
    /**
     * API used to zoom in to the trench attached with given trench ID
     * @param trenchID
     */
    fitToTrench(trenchID) {
        this._scDesign.fitToTrench(trenchID);
    }
    exportDebugLogs() {
        return this._scDesign.exportDebugLogs();
    }
    getCornerPositions(latitude, longitude, imageWidth, imageHeight, rotateDegree) {
        return EarthBrainUtils.getCornerPositions(longitude, latitude, imageWidth, imageHeight, rotateDegree);
    }
    /**
     * It accepts the z,y,z coordinates of the corners in clockwise or anticlockwise order and sets the 2D view to fit those points.
     * @param topLeft - {x: number, y: number, z: number}
     * @param topRight - {x: number, y: number, z: number}
     * @param bottomRight - {x: number, y: number, z: number}
     * @param bottomLeft - {x: number, y: number, z: number}
     */
    set2DView(topLeft, topRight, bottomRight, bottomLeft) {
        this._scDesign.set2DView(new Cartesian3(topLeft.x, topLeft.y, topLeft.z), new Cartesian3(topRight.x, topRight.y, topRight.z), new Cartesian3(bottomRight.x, bottomRight.y, bottomRight.z), new Cartesian3(bottomLeft.x, bottomLeft.y, bottomLeft.z));
    }
    /**
     * If the 2D view is set, this function will reset the projection and will allow rotation. It will not change camera position.
     */
    set3DView() {
        this._scDesign.set3DView();
    }
    /**
     * Set the camera to a 2D view (top-down) based on the current camera position.
     * The camera will maintain its current horizontal position but switch to an orthographic projection looking straight down.
     */
    set2DViewFromCurrentPosition() {
        this._scDesign.set2DViewFromCurrentPosition();
    }
    /**
     * Calculate road positions using RoadGeometry.
     * @param roadId Road ID
     * @returns { positions: {x: number, y: number, z: number}[] }
     */
    async recalculateCenterLinePositions(roadId) {
        const positions = await this._scDesign.recalculateCenterLinePositions(roadId);
        return {
            positions: positions.map((p) => ({ x: p.x, y: p.y, z: p.z })),
        };
    }
    setAltitudeTooltipCallback(callback) {
        this._scDesign.setAltitudeTooltipCallback(callback);
    }
    getCentralLineDataOfAlignment(alignmentID) {
        return this._scDesign.getCentralLineDataOfAlignment(alignmentID);
    }
    getDesignMeshGeometry(designId) {
        return this._scDesign.getDesignMeshGeometry(designId);
    }
}
//# sourceMappingURL=EarthBrainViewerAPIs.js.map